import Notifiq from "@/Pages/Notifiq/index.vue";
import IndexNotifiq from "@/Pages/Notifiq/IndexNotifiq.vue";

export default [
  {
    path: "/notifiq/index",
    name: "notifiq.index",
    component: Notifiq,
  },
  {
    path: "/notifiq/presencas",
    name: "notifiq.indexNotifiq",
    title: "Presença Notifiq",
    component: IndexNotifiq,
  },
];
